import { SEOHead } from '@/components/@next/SEOHead';
import { BlogHome } from '@/features/blog/pages/BlogHome';
import dynamic from 'next/dynamic';

const BlogLayout = dynamic(
  () => import('@/features/blog/layout/BlogLayout').then((m) => m.default),
  {
    ssr: false,
  },
);

export default function BlogPage() {
  return (
    <>
      <SEOHead
        title="Secure Trade Club Blog"
        description="Stay updated with the latest news, tutorials, and events in the world of collectibles. Join the Secure Trade Club community and learn from our expert insights."
        ogType="website"
        canonical="https://securetradeclub.com/blog"
      />

      <BlogLayout>
        <BlogHome />
      </BlogLayout>
    </>
  );
}
